// src/components/steps2.js
import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import './steps2.css'
import { useTranslation } from 'react-i18next'

const Steps2 = ({
  step1Description = undefined,
  step3Description = undefined,
  step2Title = undefined,
  step2Description = undefined,
  step1Title = undefined,
  step3Title = undefined,
  step4Description = undefined,
  step4Title = undefined,
}) => {
  const { t } = useTranslation();

  const handleActionClick = () => {
    const pricingEl = document.getElementById('pricing') || document.querySelector('[ref="pricingRef"]');
    if (pricingEl) {
      pricingEl.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/#pricing';
    }
  };

  return (
    <section className="steps2-container1 thq-section-padding">
      <div className="steps2-max-width thq-section-max-width">
        <div className="steps2-layout">
          
          {/* Left Column: Intro Header */}
          <div className="steps2-section-header">
            <h2 className="steps2-title thq-heading-2">
              {t('home.step.heading')}
            </h2>
            <p className="steps2-subtitle thq-body-large">
              {t('home.step.content')}
            </p>
            <div className="steps2-actions">
              <button 
                type="button"
                className="steps2-button"
                onClick={handleActionClick}
              >
                <span>{t('home.step.action')}</span>
                <span>→</span>
              </button>
            </div>
          </div>

          {/* Right Column: Step Cards */}
          <div className="steps2-cards-container">
            
            {/* Step 01 */}
            <div className="steps2-card step-card-1">
              <div className="steps2-card-header">
                <span className="steps2-badge">01</span>
                <h3 className="steps2-step-title">
                  {step1Title ?? (
                    <Fragment>
                      <span>{t('home.step.step1.title')}</span>
                    </Fragment>
                  )}
                </h3>
              </div>
              <p className="steps2-step-desc">
                {step1Description ?? (
                  <Fragment>
                    <span>{t('home.step.step1.description')}</span>
                  </Fragment>
                )}
              </p>
            </div>

            {/* Step 02 */}
            <div className="steps2-card step-card-2">
              <div className="steps2-card-header">
                <span className="steps2-badge">02</span>
                <h3 className="steps2-step-title">
                  {step2Title ?? (
                    <Fragment>
                      <span>{t('home.step.step2.title')}</span>
                    </Fragment>
                  )}
                </h3>
              </div>
              <p className="steps2-step-desc">
                {step2Description ?? (
                  <Fragment>
                    <span>{t('home.step.step2.description')}</span>
                  </Fragment>
                )}
              </p>
            </div>

            {/* Step 03 */}
            <div className="steps2-card step-card-3">
              <div className="steps2-card-header">
                <span className="steps2-badge">03</span>
                <h3 className="steps2-step-title">
                  {step3Title ?? (
                    <Fragment>
                      <span>{t('home.step.step3.title')}</span>
                    </Fragment>
                  )}
                </h3>
              </div>
              <p className="steps2-step-desc">
                {step3Description ?? (
                  <Fragment>
                    <span>{t('home.step.step3.description')}</span>
                  </Fragment>
                )}
              </p>
            </div>

            {/* Step 04 */}
            <div className="steps2-card step-card-4">
              <div className="steps2-card-header">
                <span className="steps2-badge">04</span>
                <h3 className="steps2-step-title">
                  {step4Title ?? (
                    <Fragment>
                      <span>{t('home.step.step4.title')}</span>
                    </Fragment>
                  )}
                </h3>
              </div>
              <p className="steps2-step-desc">
                {step4Description ?? (
                  <Fragment>
                    <span>{t('home.step.step4.description')}</span>
                  </Fragment>
                )}
              </p>
            </div>

          </div>
        </div>
      </div>
    </section>
  )
}

Steps2.propTypes = {
  step1Description: PropTypes.element,
  step3Description: PropTypes.element,
  step2Title: PropTypes.element,
  step2Description: PropTypes.element,
  step1Title: PropTypes.element,
  step3Title: PropTypes.element,
  step4Description: PropTypes.element,
  step4Title: PropTypes.element,
}

export default Steps2